import React, { Component } from 'react';
import cx from 'classnames';
import { SizeMe } from 'react-sizeme';
import _memoize from 'lodash.memoize';
import _omit from 'lodash.omit';
import _get from 'lodash.get';


import { List, Text } from '../../../../../ui-kit';

import { hasPermission } from '../../../../requiresPermission';
import { notify } from '../../../../Notifications';
import DropZone from '../../DropZone';
import AssetsListCard from './AssetsListCard';
import { AssetLibraryBulkActions as bulkActions } from '../../../../../common/constants';
import { mediaSizes, sortingOptions } from '../../../constants';
import { getAdvancedFilters } from '../../../utils';
import FolderTreeMenu from './FolderTreeMenu';

import CONFIRM_ACTION from '../../ConfirmationModal/constants/confirmActions';
import DeleteConfirmationModal from '../../../../DeleteConfirmationModal';
import ConfirmationModal from '../../ConfirmationModal';
import ManageAssetModal from '../../../../ManageAssetModal';
import BulkActionModal from '../../../../AssetsBulkActionModal';

import '../styles/_assets-list.scss';

























































const IN_PROGRESS = 'IN_PROGRESS';
const SEARCH_FILTER = {
  filterType: 'SEARCH',
  defaultValue: ''
};

const permissions = {
  ARCHIVE: 'ARCHIVE',
  DELETE_ASSET: 'DELETE_ASSET'
};

export default class AssetsList extends Component {






  showManageAssetModal = _memoize(({ assetId }) => () => {
    this.setState({
      showManageAssetsModal: true,
      assetId
    });
  });

  constructor(props) {
    super(props);

    this.state = {
      assetTitle: '',
      showDeleteConfirmationModal: false,
      showAssetActionConfirmationModal: false,
      confirmModalAction: '',
      showManageAssetsModal: false,
      showBulkActionModal: false,
      bulkAction: '',
      selectedAssets: []
    };

    this.dropZoneRef = React.createRef();
    this._pendingTagChanges = [];
    this.handleTagDropComplete = () => {
      this.setState({ selectedAssets: [] });
    };
  }

  componentDidMount() {
    document.addEventListener('tag-drop-complete', this.handleTagDropComplete);
  }

  componentWillUnmount() {
    document.removeEventListener('tag-drop-complete', this.handleTagDropComplete);

    // Flush pending tag changes on unmount
    const { onAssetTagToggled } = this.props;
    if (this._pendingTagChanges.length > 0 && onAssetTagToggled) {
      onAssetTagToggled();
      this._pendingTagChanges = [];
    }
  }

  getOptions = (asset) => {
    const { archivedFilter, orgPermissions, isListEditable, allTags, assetTagMap } = this.props;

    // Which folders this asset is currently in (server data + pending changes).
    const serverTagIds = assetTagMap && assetTagMap[asset.assetId] || [];
    const taggedTagIds = (allTags || []).
    filter((tagObj) => {
      const isTaggedOnServer = serverTagIds.includes(tagObj.tagId);
      const isPendingAdd = this._pendingTagChanges.some(
        (p) => p.assetId === asset.assetId && p.tagId === tagObj.tagId && p.action === 'tag'
      );
      const isPendingRemove = this._pendingTagChanges.some(
        (p) => p.assetId === asset.assetId && p.tagId === tagObj.tagId && p.action === 'untag'
      );
      return isTaggedOnServer && !isPendingRemove || isPendingAdd;
    }).
    map((tagObj) => tagObj.tagId);

    // "Add to folder..." stays the parent row (with the arrow); its flyout holds
    // a single item = the sidebar-style collapsible folder tree, which owns its
    // own expand/search/tick state so menu interactions don't rebuild options.
    const folderMenuItem = [{
      label: 'Add to folder...',
      className: 'tag-folder-submenu',
      submenu: [{
        label:
        <FolderTreeMenu
          tags={allTags || []}
          taggedTagIds={taggedTagIds}
          onToggleTag={(tagObj) => this.handleToggleAssetTag(asset.assetId, tagObj)}
          onCreateFolder={() => document.dispatchEvent(new CustomEvent('open-create-folder'))} />,

        action: () => {},
        keepOpen: true
      }]
    }];

    if (!isListEditable) {
      return [
      { label: 'View Details', action: this.showManageAssetModal(asset) },
      ...folderMenuItem];

    }

    const hasArchivePermission = hasPermission(permissions.ARCHIVE, asset.permissions);
    const hasDeletePermission = hasPermission(permissions.DELETE_ASSET, orgPermissions);
    const isInProgress = _get(asset, 'assetFiles.ORIGINAL.status', IN_PROGRESS) === IN_PROGRESS;

    return [
    { label: 'Manage Details', action: this.showManageAssetModal(asset) },
    ...folderMenuItem,
    ...(archivedFilter === 'ARCHIVED' && hasArchivePermission ? [{
      action: this.handleAssetAction({
        asset,
        confirmModalAction: CONFIRM_ACTION.UNARCHIVE
      }),
      label: 'Unarchive'
    }] : []),
    ...(archivedFilter !== 'ARCHIVED' && hasArchivePermission ? [{
      action: this.handleAssetAction({
        asset,
        confirmModalAction: CONFIRM_ACTION.ARCHIVE
      }),
      label: 'Send To Archive'
    }] : []),
    ...(archivedFilter === 'ARCHIVED' && !isInProgress && hasDeletePermission ? [{
      action: this.handleDeleteAsset({ asset }),
      label: 'Delete',
      isRed: true
    }] : [])];

  };

  getBulkActionOptions = _memoize((archivedFilter, assets) => {
    const { orgPermissions } = this.props;

    const hasArchivePermission = assets.every(
      (asset) => hasPermission(permissions.ARCHIVE, asset.permissions)
    );
    const hasDeletePermission = hasPermission(permissions.DELETE_ASSET, orgPermissions);
    const isInProgress = assets.some((asset) => _get(asset, 'assetFiles.ORIGINAL.status', IN_PROGRESS) === IN_PROGRESS);

    return [
    ...(archivedFilter === 'ARCHIVED' && !isInProgress && hasDeletePermission ? [
    { icon: 'trash', action: this.handleBulkDelete, label: 'Delete' }] :
    []),
    ...(archivedFilter === 'ARCHIVED' && hasArchivePermission ? [
    { icon: 'refresh', action: this.handleBulkUnArchive, label: 'Unarchive' }] :
    []),
    ...(archivedFilter !== 'ARCHIVED' && hasArchivePermission ? [
    { icon: 'archive', action: this.handleBulkArchive, label: 'Archive' }] :
    [])];

  });

  handleFilterChange = (data) => {
    const { onFilterChange } = this.props;
    onFilterChange(data);

    this.setState({
      selectedAssets: []
    });
  };

  handleAdvancedFilterChange = (data) => {
    const { onAdvancedFilterChange } = this.props;
    onAdvancedFilterChange(data);

    this.setState({
      selectedAssets: []
    });
  };

  handleDeleteAsset = ({ asset }) => () => {
    this.setState({
      assetId: asset.assetId,
      assetTitle: asset.title || 'Asset',
      showDeleteConfirmationModal: true
    });
  };

  handleHideDeleteConfirmationModal = () => {
    this.setState({ showDeleteConfirmationModal: false });
  };

  handleDeleteComplete = () => {
    const { onDeleteComplete } = this.props;
    const { assetId, assetTitle } = this.state;

    this.setState({ showDeleteConfirmationModal: false }, () => {
      notify({ content: `${assetTitle} successfully deleted`, type: 'success' });
      onDeleteComplete(assetId);
    });
  };

  handleAssetAction = ({
    asset,
    confirmModalAction



  }) => () => {
    this.setState({
      assetId: asset.assetId,
      assetTitle: asset.title || 'Asset',
      showAssetActionConfirmationModal: true,
      confirmModalAction
    });
  };

  handleHideAssetActionConfirmationModal = () => {
    this.setState({ showAssetActionConfirmationModal: false });
  };

  handleAssetActionComplete = () => {
    const { onAssetActionComplete } = this.props;
    const { assetId, confirmModalAction } = this.state;

    this.setState({ showDeleteConfirmationModal: false }, () => {
      onAssetActionComplete(assetId, confirmModalAction);
    });
  };

  handleCloseManageAssetModal = () => {
    this.setState({
      showManageAssetsModal: false
    });
  };

  handleManageAssetModalSave = (data) => {
    const { onManageAssetModalSave } = this.props;

    onManageAssetModalSave(data);
  };

  handleBulkSelect = (assets) => {
    const { onBulkSelectAssets } = this.props;

    this.setState({
      selectedAssets: [...assets]
    });

    if (onBulkSelectAssets) {
      onBulkSelectAssets(assets);
    }
  };

  handleBulkArchive = () => {
    this.setState({ showBulkActionModal: true, bulkAction: bulkActions.ARCHIVE });
  };

  handleBulkUnArchive = () => {
    this.setState({ showBulkActionModal: true, bulkAction: bulkActions.UNARCHIVE });
  };

  handleToggleAssetTag = async (assetId, tagObj) => {
    const { tagAssetResource, untagAssetResource, assetTagMap } = this.props;

    // Check if asset currently has this tag (from server data + pending changes)
    const serverTagIds = assetTagMap && assetTagMap[assetId] || [];
    const isTaggedOnServer = serverTagIds.includes(tagObj.tagId);
    const isPendingAdd = this._pendingTagChanges.some((p) => p.assetId === assetId && p.tagId === tagObj.tagId && p.action === 'tag');
    const isPendingRemove = this._pendingTagChanges.some((p) => p.assetId === assetId && p.tagId === tagObj.tagId && p.action === 'untag');
    const hasTag = isTaggedOnServer && !isPendingRemove || isPendingAdd;

    // Remove any existing pending change for this asset+tag combo
    this._pendingTagChanges = this._pendingTagChanges.filter(
      (p) => !(p.assetId === assetId && p.tagId === tagObj.tagId)
    );

    // Add the new pending change
    this._pendingTagChanges.push({
      assetId,
      tagId: tagObj.tagId,
      action: hasTag ? 'untag' : 'tag'
    });

    // Trigger counter + tick update via DOM events (avoids React re-render)
    document.dispatchEvent(new CustomEvent('tag-animated', {
      detail: { tag: tagObj.label, type: hasTag ? 'removed' : 'added' }
    }));
    document.dispatchEvent(new CustomEvent('tag-count-changed', {
      detail: { tag: tagObj.label, delta: hasTag ? -1 : 1 }
    }));

    // Update tick in DOM directly (no re-render needed)
    try {
      const tick = document.querySelector(`[data-tag-tick="${tagObj.label}"]`);
      if (tick) {
        tick.style.color = hasTag ? 'transparent' : '#27baa1';
      }
    } catch (domErr) {

      // Ignore DOM manipulation errors
    }
    // Fire the mutation immediately
    try {
      if (hasTag) {
        await untagAssetResource({ tagId: tagObj.tagId, assetId });
      } else {
        await tagAssetResource({ tagId: tagObj.tagId, assetId });
      }
    } catch (err) {
      notify({ content: 'Failed to update tag', type: 'error' });
    }
  };

  handleTagMenuClose = () => {
    const { onAssetTagToggled } = this.props;

    // Notify parent with changes to update assetTagMap and refresh tag counts
    if (this._pendingTagChanges.length > 0 && onAssetTagToggled) {
      onAssetTagToggled([...this._pendingTagChanges]);
      this._pendingTagChanges = [];
    }
  };

  handleBulkDelete = () => {
    this.setState({ showBulkActionModal: true, bulkAction: bulkActions.DELETE });
  };

  handleBulkActionModalClose = () => {
    this.setState({ showBulkActionModal: false });
  };

  handleBulkActionComplete = (data) => {
    const { onBulkActionComplete } = this.props;
    const { selectedAssets, bulkAction } = this.state;

    if (bulkAction === bulkActions.EDIT_TAGS) {
      this.setState({
        showBulkActionModal: false
      }, () => {
        onBulkActionComplete(
          selectedAssets.map((asset) => asset.assetId),
          bulkAction,
          data
        );
      });
    } else {
      this.setState({
        showBulkActionModal: false,
        selectedAssets: []
      }, () => {
        onBulkActionComplete(
          selectedAssets.map((asset) => asset.assetId),
          bulkAction,
          data
        );
      });
    }
  };

  rowRenderer = ({ key, index, style }) => {
    const { assets = [] } = this.props;
    return (
      <div key={key} style={style}>
        {/* $FlowFixMe
           * Cannot get assets[index] because an index signature declaring the expected key /
           * value type is missing in null or undefined [1].
           */}
        {this.renderListItem(assets[index])}
      </div>);

  };

  renderCardItem = (asset) => {
    const {
      isProjectBrief,
      handleAddToProjectBriefClick,
      selectedDrawerItemIds
    } = this.props;

    const { selectedAssets } = this.state;
    // Pro Workflow: interact with the drawer checkbox rather than bulk-actions.
    const selectedAssetIds = isProjectBrief ?
    selectedDrawerItemIds || [] :
    selectedAssets.map((a) => a.assetId);

    return (
      <AssetsListCard
        item={asset}
        handleClick={this.showManageAssetModal(asset)}
        options={this.getOptions(asset)}
        onMenuClose={this.handleTagMenuClose}
        handleAddToProjectBriefClick={(assetData) => handleAddToProjectBriefClick(assetData)}
        isProjectBrief={isProjectBrief}
        selectedDrawerItemIds={selectedDrawerItemIds}
        selectedAssetIds={selectedAssetIds}
        isBulkSelected={selectedAssetIds.includes(asset.assetId)} />);


  };

  browseFiles = () => {
    if (this.dropZoneRef.current) {
      this.dropZoneRef.current.handleUploadClick();
    }
  };

  render() {
    const {
      setFilePickerRef,
      history,
      loading,
      assets,
      users,
      organisationName,
      dropZoneDisplayed,
      closeDropZone,
      loadMoreResults,
      totalResults,
      getListRef,
      listProps = {},
      withBulkActions,
      isListEditable,
      showActiveFilter = true,
      showSortingDropdown,
      deleteAsset,
      archivedFilter,
      filterByAssetType,
      searchInputPlaceholder,
      addedByDefault,
      isProjectBrief,
      selectedDrawerItemIds
    } = this.props;

    const {
      assetId,
      showDeleteConfirmationModal,
      confirmModalAction,
      showAssetActionConfirmationModal,
      showManageAssetsModal,
      showBulkActionModal,
      selectedAssets,
      bulkAction
    } = this.state;

    const dropzoneVisible = isListEditable && !loading && dropZoneDisplayed;
    const { renderCardItem: passedCardItem } = listProps;

    const filtersObj = {};
    const advancedFiltersArr = getAdvancedFilters(users, addedByDefault);

    if (!showActiveFilter) {
      const isArchivedIndex = advancedFiltersArr.findIndex((filter) => filter.name === 'isArchived');
      if (isArchivedIndex > -1) {
        advancedFiltersArr.splice(isArchivedIndex, 1);
      }
    }

    if (filterByAssetType && filterByAssetType.length) {
      const fileTypeIndex = advancedFiltersArr.findIndex((filter) => filter.name === 'fileType');
      advancedFiltersArr.splice(fileTypeIndex, 1);
    }

    if (showSortingDropdown) {
      filtersObj.sortBy = sortingOptions;
    }

    const canSelectItems = listProps && listProps.canSelectItems;

    const newListProps = {
      ...listProps,
      ...(withBulkActions ? {
        bulkActions: this.getBulkActionOptions(archivedFilter, selectedAssets),
        bulkActionsSuffix: 'assets'
      } : {}),
      ...(withBulkActions || canSelectItems ? {
        onSelectItems: (data) => this.handleBulkSelect(data)
      } : {})
    };

    const updatedSelectedAssets = selectedAssets.map(
      (selectedAsset) => assets.find((asset) => asset.assetId === selectedAsset.assetId)
    );

    return (
      <SizeMe>
        {({ size }) =>
        <div
          className={cx(
            'library-asset-list',
            'column',
            {
              'library-asset-list--hide-assets': dropzoneVisible,
              'library-asset-list--small': size.width < mediaSizes.small
            }
          )}>

            <DropZone
            setFilePickerRef={setFilePickerRef}
            closeDropZone={closeDropZone}
            isVisible
            handleDragOut={closeDropZone}
            dropZoneRef={this.dropZoneRef} />

            {!dropzoneVisible &&

          <List
            autoHeight
            height={2000}
            loading={loading}
            history={history}
            renderCardItem={passedCardItem !== void 0 ? passedCardItem : this.renderCardItem}
            data={assets.filter(({ product }) => product !== 'CAST')}
            filters={filtersObj}
            onFiltersChange={this.handleFilterChange}
            options={[]}
            searchFilter={SEARCH_FILTER}
            searchInputPlaceholder={searchInputPlaceholder}
            advancedFilters={advancedFiltersArr}
            onAdvancedFiltersChange={this.handleAdvancedFilterChange}
            listKey="assetId"
            loadMoreResults={loadMoreResults}
            totalResults={totalResults}
            getInfiniteScrollParent={getListRef}
            isProjectBrief={isProjectBrief}
            selectedDrawerItemIds={selectedDrawerItemIds}
            shouldReturnOptionAllSelections
            actionButton={
            {
              isVisible: true,
              text: 'Upload Assets',
              type: 'PRIMARY',
              onClick: this.browseFiles
            }}

            {..._omit(newListProps, ['renderCarditem', 'getInfiniteScrollParent'])} />}



            {showDeleteConfirmationModal && assetId &&
          <DeleteConfirmationModal
            onDelete={deleteAsset}
            objectId={assetId}
            hideModal={this.handleHideDeleteConfirmationModal}
            onComplete={this.handleDeleteComplete}
            title="Delete Asset" />}


            {showAssetActionConfirmationModal && assetId &&
          <ConfirmationModal
            organisationName={organisationName}
            visible={showAssetActionConfirmationModal}
            hideModal={this.handleHideAssetActionConfirmationModal}
            assetId={assetId}
            confirmModalAction={confirmModalAction}
            onConfirmation={this.handleAssetActionComplete} />}


            {showManageAssetsModal && assetId &&
          <ManageAssetModal
            assetId={assetId}
            isVisible={showManageAssetsModal}
            onClose={this.handleCloseManageAssetModal}
            onSave={this.handleManageAssetModalSave}
            readOnly={!isListEditable} />}


            {showBulkActionModal && updatedSelectedAssets.length &&
          <BulkActionModal
            action={bulkAction}
            organisationName={organisationName}
            visible={showBulkActionModal}
            onClose={this.handleBulkActionModalClose}
            selectedAssets={updatedSelectedAssets}
            onActionComplete={this.handleBulkActionComplete} />}


          </div>}

      </SizeMe>);

  }
}